import React, { Component } from 'react';
import moment from 'moment';
import viewHelper from './../../helpers/view';
import CONSTANTS from "../../constants";

export default class ConfirmAppointment extends Component {

    confirmAppointment() {
        let newState = {...this.props, confirm: true};
        this.props.callbackToUpdateComponent(newState);
    }

    render () {
        return (
            <div>
                <div className='col-xs-12 col-md-6 col-lg-6'>
                    <div className='info-box'>
                        <h3>When</h3>
                        <div>{moment(this.props.date, CONSTANTS.DATE.FORMAT.DEFAULT).format('dddd, MMMM D, YYYY')} {this.props.startTime} - {this.props.endTime}</div>
                    </div>
                </div>
                <div className='col-xs-6 col-md-6 col-lg-6'>
                    <div className='info-box'>
                        <h3>What</h3>
                        <div>{this.props.activity.description}</div>
                    </div>
                </div>
                <div className='col-xs-6 col-md-12 col-lg-12'>
                    <div className='info-box'>
                        <h3>With</h3>
                        <div>{viewHelper.getFullName(this.props.trainer)}</div>
                    </div>
                </div>
                <div className='col-xs-12 col-md-12 col-lg-12'>
                    <button className='btn btn-primary' onClick={this.confirmAppointment.bind(this)} >Confirm</button>
                </div>
            </div>
        )
    }
}
